import { render, staticRenderFns } from "./BusinessProcess.vue?vue&type=template&id=2338aebd&scoped=true&"
import script from "./BusinessProcess.vue?vue&type=script&lang=js&"
export * from "./BusinessProcess.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProcess.vue?vue&type=style&index=0&id=2338aebd&lang=less&scoped=true&"
import style1 from "./BusinessProcess.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2338aebd",
  null
  
)

export default component.exports